/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterFraming_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFramingInput_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterFraming_itemSearch";
};
export type SbSharedRefineMenuFilterFraming_itemSearch$data = SbSharedRefineMenuFilterFraming_itemSearch;
export type SbSharedRefineMenuFilterFraming_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterFraming_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterFraming_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterFraming_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFramingInput_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'efd80c34ad6ef1e1fa253506ab6dcce2';
export default node;
